/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaProveedoresVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaProveedores: React.FunctionComponent<ITablaProveedoresVistaProps & InjectedIntlProps> = ({
    proveedoress,
    cargarProveedores,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={proveedoress}
            actions={acciones(manejarFormulario, cargarProveedores, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaProveedores);
